import { Body, Micro } from '@vds/typography';
import { InHomeUtils } from './../../../util/inhomeUtils';
import DowncaretIcon from '@vds/icons/down-caret';
import UpcaretIcon from '@vds/icons/up-caret';
import { ButtonIcon } from '@vds/button-icons';

const isMobile = (window.screen.width < 768) ? true : false;
const ContentRenderComp = (props) => {
    
    let mainTitle = '';
    let subText = "";  
    
    if(!props.showContent){
      return '';
    }

    if(props?.mainTitle && (props?.price || props?.id==='ONETIMECHARGE')){
      mainTitle = <div className="bpp-cart">
       <span className='inline-block orderSumContent'>
            <Body size="small" className="padding-left" viewport={InHomeUtils.getdeviceType()} color="black">
              <div className="margin-left-micro" >
              <h3 className={`orderSumSecHeading ${props?.displayBold ? "bold" : ''} `} aria-hidden='false'>{props.mainTitle}</h3>
              </div>
            </Body>            
          </span>

          <span className='right inline-block  orderSumPrice' aria-hidden='false'>
            <span className={props.priceColor ? 'totalDiscount-color' : props?.displayBold ? 'bold' : ''}>{props?.price}</span>
              {props?.showCaretIcon && 
                <span className="bold vzicon caretCursor caretIconMargin" aria-live={"polite"} >
                  <span aria-label={`clickable ${props?.price} ${props?.toggleCaretIcon ? 'expanded' : 'collapsed'}`}></span>
                  <ButtonIcon 
                    tabIndex="0"
                    data-reveal-toggle-class="close open"
                    role="button"
                    onClick={(e) => props?.onClick()}
                    onKeyDown={(e) => props?.onKeyDown()}
                    data-promotions=""
                    fitToIcon={true}
                    focusBorderPosition="inside" 
                    title={`clickable ${props?.price} Collapsed`} 
                    kind="ghost"
                    renderIcon={(size, color) => 
                      !props?.toggleCaretIcon ? (<DowncaretIcon size="small" 
                        ariaHidden="true"
                          color="#A7A7A7" 
                        /> ): (<UpcaretIcon size="small" 
                        ariaHidden="true"
                          color="#A7A7A7" 
                        />)
                      }
                  />
                </span>
              }
          </span>
          {props?.strikeOutPrice &&  <span className={ "perksStrickoutPrice" }><span className="sr-only">previous price was </span>{props?.strikeOutPrice}</span>}
      </div>
    }
   
    if(props?.subText){
        subText = <div className="margin-left-micro bpp-cart">
          {isMobile ? <div className="setupwaived tiny-p-45"><Micro color="#6F7171">{props?.subText}</Micro></div>
          : <Body size="small" color="#6F7171">{props?.subText}</Body>}     
        </div>
      }

    const renderClassName = props?.id === "MONTHLYSAVINGS" || (props?.id === "ONETIMESAVINGS" && props?.toggleCaretIcon) ? 'orderSumSecTopAlign' : 'orderSumSecAlign' ;
    return (<>
        {props?.horizontalLine && <hr aria-hidden="true" className="stretch-new ecReskinReviewOrder" />}

        <div className={renderClassName} data-promotions="">  
          {props?.subscript ? 
          <div className="ordSumSubscript">
            {isMobile ? <div className="setupwaived tiny-p-45"><Micro color="#6F7171">{props?.subscript}</Micro></div>
            : <Body size="small" color="#6F7171">{props?.subscript}</Body>}</div>:''}
          {mainTitle}
          {subText}
        </div>

        {props?.listItems && <ul className={props?.toggleCaretIcon ? 'cart-width orderSumReskin' : 'hide'}>{props?.listItems}</ul>}
    </>) ;
  }

export default ContentRenderComp;